import style from "./Moto.module.css";
export default function Moto() {
  return <div className={style.text}>Quality, a way of life</div>;
}
